module.exports = __webpack_public_path__ + "img/USPowerBall.8bb55bd0.png";